(() => {
  const mq = window.matchMedia('(max-width: 767px)');

  let io = null;
  let bar = null;
  let mo = null;

  const enable = () => {
    if (io || bar) return;

    const form =
      document.querySelector('product-form form[action^="/cart/add"]') ||
      document.querySelector('form[action^="/cart/add"]');
    if (!form) return;

    const submit = form.querySelector('button[type="submit"][name="add"]');
    if (!submit) return;

    const anchor = submit.closest('.product-form__buttons') || submit;

    // Get product handle from product-info data-url or window.location
    const productInfo = document.querySelector('product-info[data-url]');
    const productUrl = productInfo ? productInfo.dataset.url : window.location.pathname;
    const productHandle = productUrl.split('/products/')[1]?.split('?')[0] || '';

    // CSS einmalig injizieren
    if (!document.getElementById('pdp-sticky-atc-style')) {
      const style = document.createElement('style');
      style.id = 'pdp-sticky-atc-style';
      style.textContent = `
        .pdp-sticky-atc{
          position:fixed;bottom:0;left:0;right:0;z-index:998;
          background:#fff;
          box-shadow:0 -2px 10px rgba(0,0,0,0.1);
          padding:8px 16px calc(8px + env(safe-area-inset-bottom));
          transform:translateY(110%);
          visibility:hidden;
          overflow:hidden;
          transition:transform .3s ease, visibility 0s .3s;
        }
        .pdp-sticky-atc.is-visible{transform:translateY(0);visibility:visible;transition:transform .3s ease, visibility 0s;}
        .pdp-sticky-atc__btn{
          width:100%;height:44px;
          background:#000;color:#fff;
          border:none;border-radius:0;
          font-size:14px;font-weight:700;font-family:inherit;
          text-transform:uppercase;letter-spacing:0.5px;
          cursor:pointer;transition:opacity .15s ease;
        }
        .pdp-sticky-atc__btn:disabled{opacity:0.4;cursor:not-allowed;}
        .pdp-sticky-atc .pdp-sticky-atc__btn.qa-trigger{
          position:static !important;
          width:100% !important;
          height:44px !important;
          border-radius:0 !important;
          background:#000 !important;
          color:#fff !important;
          font-size:14px !important;
          font-weight:700 !important;
          text-transform:uppercase !important;
          letter-spacing:0.5px !important;
          padding:0 16px !important;
          border:none !important;
          box-shadow:none !important;
          display:flex !important;
          align-items:center !important;
          justify-content:center !important;
          white-space:nowrap !important;
        }
        body.overflow-hidden .pdp-sticky-atc,
        body.overflow-hidden-tablet .pdp-sticky-atc,
        body.overflow-hidden-desktop .pdp-sticky-atc{transform:translateY(100%)!important;}
        html.has-sticky-atc body{padding-bottom:60px;}
      `;
      document.head.appendChild(style);
    }

    // Build sticky bar
    bar = document.createElement('div');
    bar.className = 'pdp-sticky-atc';
    bar.innerHTML =
      '<button type="button" class="pdp-sticky-atc__btn qa-trigger" data-product-handle="' + productHandle + '">In den Warenkorb</button>';
    document.body.appendChild(bar);

    const stickyBtn = bar.querySelector('.pdp-sticky-atc__btn');

    // Sync button label with original (but never disabled — drawer always opens)
    const syncButton = () => {
      const s1 = submit.querySelector('span');
      if (s1) stickyBtn.textContent = s1.textContent.trim();
    };

    // DEV-2026-0464: Drawer startet mit der Menge, die auf der Produktseite gerade gewählt ist
    // (Vorauswahl, ?variant= oder Kundenwahl). Der Quick-Add-Drawer liest sie aus data-pack-wish;
    // ausverkauft -> nächstkleinere Menge. Ohne Option "Menge" bleibt das Attribut weg.
    // Capture-Phase, damit der Wert vor dem Klick-Handler des Drawers (document, Bubble) steht.
    stickyBtn.addEventListener(
      'click',
      () => {
        const checked = document.querySelector('[data-pack-option] input[data-pack-qty]:checked');
        const qty = checked ? Number(checked.dataset.packQty) : 0;
        if (qty > 0) stickyBtn.dataset.packWish = String(qty);
        else delete stickyBtn.dataset.packWish;
      },
      true
    );

    // Observe original button for label changes
    syncButton();
    mo = new MutationObserver(syncButton);
    mo.observe(submit, { attributes: true, childList: true, subtree: true });

    // IntersectionObserver: show/hide
    io = new IntersectionObserver(
      ([entry]) => {
        const isInView = entry.isIntersecting;
        const isAboveViewport = entry.boundingClientRect.top < 0;
        const shouldShow = !isInView && isAboveViewport;

        bar.classList.toggle('is-visible', shouldShow);
        document.documentElement.classList.toggle('has-sticky-atc', shouldShow);
      },
      { threshold: 0.15 }
    );

    io.observe(anchor);
  };

  const disable = () => {
    if (io) { io.disconnect(); io = null; }
    if (mo) { mo.disconnect(); mo = null; }

    document.documentElement.classList.remove('has-sticky-atc');

    if (bar) {
      bar.remove();
      bar = null;
    }
  };

  const update = () => (mq.matches ? enable() : disable());

  update();
  mq.addEventListener?.('change', update);
})();
